import { Injectable } from "@angular/core";
import parsePhoneNumberFromString, { isPossiblePhoneNumber } from "libphonenumber-js/max";


@Injectable({
  providedIn: 'root'
})
export class UiServicesEventHandler {

  public onlyAlphabets(event: KeyboardEvent): boolean {
    const regex = new RegExp(/^[a-zA-Z]+$/);
    const str   = event.key;
    return(regex.test(str));
  }

  public onlyNumeric(event: KeyboardEvent): boolean {
    const regex = new RegExp(/^[\d]+$/);
    const str   = event.key;
    return(regex.test(str));
  }
    
  public onlyAlphaNumeric(event: KeyboardEvent, allowEmail: boolean): boolean {
    const regex = (allowEmail)? new RegExp(/^[0-9a-zA-Z\.\-_,@+]+$/)
                              : new RegExp(/^[0-9a-zA-Z\s\.\-\|,+]+$/);
    const str   = event.key;
    return(regex.test(str));
  }

  public onlyPassword(event: KeyboardEvent): boolean {
    const regex = new RegExp(/^[0-9a-zA-Z@$#!&*%\-]+$/);
    const str   = event.key;
    return(regex.test(str));
  }

  public onlyMessage(event: KeyboardEvent): boolean {
    const regex = new RegExp(/^[0-9a-zA-Z\s\.\-'":;&!_?,\|]+$/);
    const str   = event.key;
    return(regex.test(str));
  }

  public onlyUrl(event: KeyboardEvent): boolean {
    const regex = new RegExp(/^[0-9a-zA-Z:\/\.\-]+$/);
    const str   = event.key;
    return(regex.test(str));
  }

  public onlyZip(event: KeyboardEvent): boolean {
    const emailRegex = /^[0-9a-zA-Z\s]+$/;
    const str        = event.key;
    return(emailRegex.test(str));
  }

  public onlyNumber(event: KeyboardEvent, allowPlus = false): boolean {
    const str = event.key;

    if(allowPlus && str === '+' && (event.shiftKey || event.code === 'NumpadAdd')) {
      return true;
    }
    
    if (/^[0-9]$/.test(str)) {
      return true;
    }
    return false;
  }

  public onlyDecimal(event: KeyboardEvent): boolean {
    const phRegex = new RegExp(/^[0-9.]+$/);
    const str     = event.key;
    return(phRegex.test(str));
  }

  public isValidPhoneNumber(phoneNumber: string): boolean {
    const allowedCharsRegex = /^[+\d().\s-]+$/;
    if(!phoneNumber || !allowedCharsRegex.test(phoneNumber)) {
      return false;
    }

    phoneNumber = phoneNumber.replace(/^00/, '+');
    const phone = parsePhoneNumberFromString(phoneNumber, 'CA');

    if(!phone || !phone.isPossible()) {
      return false;
    }

    if(!isPossiblePhoneNumber(phone.number)) {
      return false;
    }

    return true;
  }

  public isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  
    return(emailRegex.test(email));
  }
}